import React, { useEffect, useRef, useState } from "react";
import fallback from "../../assets/hotseat/winner/novo-render.png";

export default function WinnerTrophy({ active, animate }) {
  const container = useRef(null);
  const [ready, setReady] = useState(false);
  // Un trofeo nuevo (otro active/animate) no está listo hasta que WebGL lo dibuja.
  const [trophyFor, setTrophyFor] = useState({ active, animate });
  if (trophyFor.active !== active || trophyFor.animate !== animate) {
    setTrophyFor({ active, animate });
    setReady(false);
  }
  useEffect(() => {
    let cancelled = false;
    let dispose;
    if (!active || !window.WebGLRenderingContext) return undefined;
    import("./createWinnerTrophy").then(({ default: create }) => {
      if (cancelled) return;
      dispose = create(container.current, animate);
      setReady(Boolean(dispose));
    }).catch(() => { if (!cancelled) setReady(false); });
    return () => { cancelled = true; dispose?.(); };
  }, [active, animate]);
  return <div className="royal-trophy-render" ref={container} data-ready={ready}>
    <img className="royal-trophy-fallback" src={fallback} alt="" />
  </div>;
}
